import { render, staticRenderFns } from "./ScientificDegreeInfo.vue?vue&type=template&id=b88162e4&"
import script from "./ScientificDegreeInfo.vue?vue&type=script&lang=js&"
export * from "./ScientificDegreeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports